module.exports = __webpack_public_path__ + "static/media/comingSoon.e2e3ddff.svg";